import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';


const endpoint = apiUrl + 'v2';

async function getVehiclesList(filters = {}) {
  const user = getLoggedUser();
  
  const params = new URLSearchParams();
  
  if (filters.status && filters.status !== 'all') {
    params.append('status', filters.status);
  }
  if (filters.page) {
    params.append('page', filters.page);
  }
  if (filters.per_page) {
    params.append('per_page', filters.per_page);
  }
  if (filters.vehicle_number) {
    params.append('vehicle_number', filters.vehicle_number);
  }
  if (filters.vehicle_type) {
    params.append('vehicle_type', filters.vehicle_type);
  }
  
  const queryString = params.toString();
  
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user?.token,
    },
  };

  try {
    // Make the API call with proper query string
    const url = `${endpoint}/vehicle-registration${queryString ? `?${queryString}` : ''}`;
    console.log('API URL:', url); // For debugging
    
    const { data: response } = await axios.get(url, config);
    console.log('API Response:', response); // For debugging
    
    return response;
  } catch (error) {
    console.error('Error fetching vehicles:', error);
    
    // Return a structured error response
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error.message,
      data: null,
      pagination: null,
      meta: null
    };
  }
}




export { getVehiclesList };